import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api, { apiErrorMessage } from "@/lib/api";
import { TRAIN } from "@/constants/testIds";

export default function TrainerLearner() {
  const { learnerId } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [note, setNote] = useState("");

  const reload = async () => {
    try { const { data } = await api.get(`/training/trainer/learners/${learnerId}`); setData(data); }
    catch (e) { setErr(apiErrorMessage(e)); }
  };
  useEffect(() => { reload(); /* eslint-disable-line */ }, [learnerId]);

  const submitNote = async () => {
    if (!note.trim()) return;
    await api.post("/training/trainer/notes", { learner_id: learnerId, body: note.trim() });
    setNote(""); await reload();
  };

  if (err) return <div className="text-rose-300">{err}</div>;
  if (!data) return <div className="font-bebas tracking-[0.3em] text-lifted-dim">LOADING…</div>;

  return (
    <div className="space-y-8 max-w-4xl">
      <Link to="/trainer" className="btn-ghost inline-flex !text-[0.7rem]">← Back to trainer console</Link>

      <header className="fade-up">
        <div className="eyebrow">Learner</div>
        <h1 className="headline-xl">{data.learner.name}</h1>
        <p className="text-lifted-dim mt-1 text-sm">{data.learner.email} · {(data.learner.roles || []).join(", ")}</p>
      </header>

      <section className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="glass-panel p-5">
          <div className="eyebrow !text-lifted-text-dim">Progress</div>
          {data.progress.length === 0
            ? <div className="text-sm text-lifted-mute mt-3">No module progress yet.</div>
            : <ul className="mt-3 space-y-2 text-sm">
                {data.progress.map((p) => (
                  <li key={p.id} className="flex justify-between">
                    <span className="text-lifted-text">{p.track_key} · module {p.module_id.slice(0, 6)}…</span>
                    <span className={p.completed ? "text-lifted-green" : "text-lifted-dim"}>
                      {p.completed ? "Complete" : `${p.completion_pct || 0}%`}
                    </span>
                  </li>
                ))}
              </ul>}
        </div>
        <div className="glass-panel p-5">
          <div className="eyebrow !text-lifted-text-dim">Certifications</div>
          {data.certifications.length === 0
            ? <div className="text-sm text-lifted-mute mt-3">No certifications.</div>
            : <ul className="mt-3 space-y-2 text-sm">
                {data.certifications.map((c) => (
                  <li key={c.id} className="flex justify-between">
                    <span className="text-lifted-text">{c.track_key}</span>
                    <code className="text-lifted-green text-xs">{c.verification_code}</code>
                  </li>
                ))}
              </ul>}
        </div>
      </section>

      <section className="glass-panel p-5">
        <div className="eyebrow !text-lifted-text-dim">Trainer notes</div>
        <ul className="mt-3 space-y-2 text-sm">
          {data.trainer_notes.map((n) => (
            <li key={n.id} className="border-l-2 border-lifted-green/30 pl-3">
              <div className="text-lifted-text">{n.body}</div>
              <div className="text-xs text-lifted-mute">{n.trainer_name} · {n.created_at}</div>
            </li>
          ))}
          {data.trainer_notes.length === 0 && <li className="text-lifted-mute">No notes yet.</li>}
        </ul>
        <div className="mt-4 flex gap-2">
          <input data-testid={TRAIN.trainerNoteInput} className="input-lifted flex-1" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Coaching note for this learner…" />
          <button data-testid={TRAIN.trainerNoteSubmit} onClick={submitNote} disabled={!note.trim()} className="btn-lifted !px-4 !py-2 !text-[0.7rem]">Save note</button>
        </div>
      </section>
    </div>
  );
}
